import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ChatPageSF from '../pages/finapp/ChatPageSF'
import OpenAIPageSF from '../pages/finapp/OpenAIPageSF'
import AlertListPageSF from '../pages/finapp/AlertListPageSF'
import OrderListPageSF from '../pages/finapp/OrderListPageSF'
import AnalyticsPageSF from '../pages/finapp/AnalyticsPageSF'
import FinAppHomePageSF from '../pages/finapp/FinAppHomePageSF'
import VendorListPageSF from '../pages/finapp/VendorListPageSF'
import BudgetListPageSF from '../pages/finapp/BudgetListPageSF'
import LoanListPageSF from '../pages/finapp/loan/LoanListPageSF'
import BankTxnListPageSF from '../pages/finapp/BankTxnListPageSF'
import OrderCreatePageSF from '../pages/finapp/OrderCreatePageSF'
import InvoiceListPageSF from '../pages/finapp/InvoiceListPageSF'
import ProjectListPageSF from '../pages/finapp/ProjectListPageSF'
import CustomerListPageSF from '../pages/finapp/CustomerListPageSF'
import BudgetDetailPageSF from '../pages/finapp/BudgetDetailPageSF'
import LoanDetailPageSF from '../pages/finapp/loan/LoanDetailPageSF'
import InvoiceDetailPageSF from '../pages/finapp/InvoiceDetailPageSF'
import OrderItemListPageSF from '../pages/finapp/OrderItemListPageSF'
import VendorBillListPageSF from '../pages/finapp/VendorBillListPageSF'
import TransactionListPageSF from '../pages/finapp/TransactionListPageSF'
import DirectorListPageSF from '../pages/finapp/signup/DirectorListPageSF'
import ZTransactionListPageSF from '../pages/finapp/ZTransactionListPageSF'
import OrderInvoiceListPageSF from '../pages/finapp/OrderInvoiceListPageSF'

const FinAppRouteUI = ({ context }) =>
  <Switch>
    <Route exact path='/alerts'
      render={() =>
        <AlertListPageSF context={context} />
      }
    />

    <Route exact path='/budgets/:budgetId'
      render={() =>
        <BudgetDetailPageSF context={context} />
      }
    />

    <Route exact path='/home'
      render={() =>
        <FinAppHomePageSF context={context} />
      }
    />
    <Route exact path='/support/chat'
      render={() =>
        <ChatPageSF context={context} />
      }
    />
    <Route exact path='/support/openai'
      render={() =>
        <OpenAIPageSF context={context} />
      }
    />

    <Route exact path='/invoices'
      render={() =>
        <InvoiceListPageSF context={context} />
      }
    />
    <Route exact path='/invoices/:invoiceId'
      render={() =>
        <InvoiceDetailPageSF context={context} />
      }
    />

    <Route exact path='/orders'
      render={() =>
        <OrderListPageSF context={context} />
      }
    />
    <Route exact path='/orders/create'
      render={() =>
        <OrderCreatePageSF context={context} />
      }
    />
    <Route exact path='/orders/:orderId/budgets'
      render={() =>
        <BudgetListPageSF context={context} />
      }
    />
    <Route exact path='/orders/:orderId/invoices'
      render={() =>
        <OrderInvoiceListPageSF context={context} />
      }
    />
    <Route exact path='/orders/:orderId/items'
      render={() =>
        <OrderItemListPageSF context={context} />
      }
    />

    <Route exact path='/reports'
      render={() =>
        <AnalyticsPageSF context={context} />
      }
    />

    <Route exact path='/txns/:bankAccountId'
      render={() =>
        <ZTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/txns2/:bankAccountId'
      render={() =>
        <TransactionListPageSF context={context} />
      }
    />
    <Route exact path='/txns/bank'
      render={() =>
        <BankTxnListPageSF context={context} />
      }
    />
    <Route exact path='/vendors'
      render={() =>
        <VendorListPageSF context={context} />
      }
    />
    <Route exact path='/vendorBills'
      render={() =>
        <VendorBillListPageSF context={context} />
      }
    />
    <Route exact path='/loans'
      render={() =>
        <LoanListPageSF context={context} />
      }
    />
    <Route exact path='/customers'
      render={() =>
        <CustomerListPageSF context={context} />
      }
    />
    <Route exact path='/projects'
      render={() =>
        <ProjectListPageSF context={context} />
      }
    />

    <Route exact path='/loans/:loanId'
      render={() =>
        <LoanDetailPageSF context={context} />
      }
    />
  </Switch>

export default FinAppRouteUI
